
    import './styles.scoped.css';
    export default {
  "button-dropdown": "_button-dropdown_12fv1_3",
  "items-list-container": "_items-list-container_12fv1_7",
  "awsui-motion-fade-in-0": "_awsui-motion-fade-in-0_12fv1_1",
  "rotate-up": "_rotate-up_12fv1_24",
  "rotate-down": "_rotate-down_12fv1_39"
};
  